import { ClassMeta, GetClassMeta } from "../core/MetaDecorator";
import { ObjectUtils, AnyConstructor } from "./ObjectUtils";

const Init = Symbol.for("$BaseClass_init");
const MetaSymbol = Symbol.for("$Meta");

export class BaseClass {
	public static readonly Init: typeof Init = Init;
	public static readonly Meta: typeof MetaSymbol = MetaSymbol;

	protected [MetaSymbol]: ClassMeta;

	constructor() {
		(this as unknown as any).setupClass();
		this[Init]();
	}

	protected setupClass() {
		let meta = GetClassMeta(this, true);
		this[MetaSymbol] = meta;
		if (meta.isRegistered() === false) {
			meta.register(false);
		}
	}

	protected [Init]() { }

	public static Mixin<TBase extends AnyConstructor<any>>(Base: TBase) {
		const Cls = class extends Base {
			constructor(...args: any[]) {
				super(...args);
				(this as unknown as any).setupClass();
			}
		} as TBase & BaseClass;

		interface Cls extends BaseClass { }
		ObjectUtils.mixin(Cls, [BaseClass]);

		return Cls;
	}
}
